import client from './internal/httpClient';

export const listSettings = ()      => client.get('/admin/settings/list');
export const saveSettings = (items) => client.post('/admin/settings/save', { items });
